import CartInvalidator from './CartInvalidator';
import Contacts from './Contacts';
import Educations from './Educations';
import Faq from './Faq';
import FormDownloads from './FormDownloads';
import FormSafeCall from './FormSafeCall';
import FormSubscribe from './FormSubscribe';
import ProductSearch from './ProductSearch';
import ProductSlider from './ProductSlider';
import SearchResults from './SearchResults';

export default {
    CartInvalidator,
    Contacts,
    Educations,
    FormDownloads,
    FormSafeCall,
    FormSubscribe,
    ProductSearch,
    ProductSlider,
    SearchResults,
    Faq
};
